import { render, staticRenderFns } from "./LeadOriginInterest.vue?vue&type=template&id=bb2cbf64"
import script from "./LeadOriginInterest.vue?vue&type=script&lang=js"
export * from "./LeadOriginInterest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports